import { LegalLayout, LegalSection } from "@/components/site/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Use" updated="June 2026">
      <LegalSection heading="Acceptance of Terms">
        <p>
          By accessing and using the Home Cart website, you agree to these Terms
          of Use. If you do not agree, please do not use this website.
        </p>
      </LegalSection>

      <LegalSection heading="Use of the Website">
        <p>
          This website is provided for informational purposes about the Home Cart
          retail concept, product categories and business opportunities. You agree
          to use the website lawfully and not to misuse or interfere with its
          operation.
        </p>
      </LegalSection>

      <LegalSection heading="Inventory & Availability">
        <p>
          Home Cart offers products sourced from overstock, stock overruns and
          customer returns. Inventory changes regularly and varies by location.
          Product categories and images shown on this website are representative
          examples and do not guarantee availability of any specific item.
        </p>
      </LegalSection>

      <LegalSection heading="Intellectual Property">
        <p>
          All content on this website, including text, graphics, logos and images,
          is the property of Home Cart or its licensors and is protected by
          applicable laws. You may not reproduce or distribute it without
          permission.
        </p>
      </LegalSection>

      <LegalSection heading="Disclaimers">
        <p>
          This website and its content are provided "as is" without warranties of
          any kind. We do not guarantee that the website will be error-free or
          uninterrupted.
        </p>
      </LegalSection>

      <LegalSection heading="Limitation of Liability">
        <p>
          To the fullest extent permitted by law, Home Cart shall not be liable for
          any damages arising from your use of, or inability to use, this website.
        </p>
      </LegalSection>

      <LegalSection heading="Changes to These Terms">
        <p>
          We may update these Terms of Use from time to time. Continued use of the
          website after changes are posted constitutes acceptance of the updated
          terms.
        </p>
      </LegalSection>

      <LegalSection heading="Contact Us">
        <p>
          For questions about these Terms of Use, please contact us at
          info@homecart.ca.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
